import { render } from "./InvitedUoCrb.vue?vue&type=template&id=0f8f849d&scoped=true"
import script from "./InvitedUoCrb.vue?vue&type=script&lang=js"
export * from "./InvitedUoCrb.vue?vue&type=script&lang=js"

import "./InvitedUoCrb.vue?vue&type=style&index=0&id=0f8f849d&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8f849d"]])

export default __exports__